module.exports = __webpack_public_path__ + "img/abcs-select-en-c.add344cd.png";